import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import InitAutoplay from '../../scripts/initAutoplay';

Swiper.use([Navigation, Pagination, Autoplay]);

let reviewsCarousel = null;

export default () => {
  if (reviewsCarousel) {
    return;
  }

  const container = document.querySelector('.er_new-reviews__slider');
  if (!container) {
    return;
  }

  reviewsCarousel = new Swiper('.er_new-reviews__slider', {
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.er_new-reviews__inner__pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.er_new-reviews__inner__next, .er_new-reviews__inner__arrows__next',
      prevEl: '.er_new-reviews__inner__prev, .er_new-reviews__inner__arrows__prev',
    },
    spaceBetween: 30,
    resizeObserver: true,
    loop: false,
    speed: 700,
    resistanceRatio: 0.7,
    preventClicks: false,
    preventClicksPropagation: false,
  });

  const attachDragGuard = (slider, containerSelector) => {
    if (!slider) return;
    const sliderContainer = document.querySelector(containerSelector);
    if (!sliderContainer || !sliderContainer.addEventListener) return;
    const state = { moved: false, linkPressed: false };

    slider.on('touchMove', () => { state.moved = true; });
    slider.on('sliderMove', () => { state.moved = true; });
    slider.on('touchEnd', () => { setTimeout(() => { state.moved = false; }, 0); });
    slider.on('transitionEnd', () => { state.moved = false; });

    const lockTouch = () => {
      slider.allowTouchMove = false;
      state.linkPressed = true;
    };

    const unlockTouch = () => {
      setTimeout(() => {
        slider.allowTouchMove = true;
        state.linkPressed = false;
      }, 0);
    };

    sliderContainer.addEventListener('pointerdown', (e) => {
      const link = e.target.closest('a.er_new-reviews__card__content__link');
      if (link) lockTouch();
    }, true);

    sliderContainer.addEventListener('pointerup', (e) => {
      if (state.linkPressed) unlockTouch();
    }, true);

    sliderContainer.addEventListener('touchstart', (e) => {
      const link = e.target.closest('a.er_new-reviews__card__content__link');
      if (link) lockTouch();
    }, true);

    sliderContainer.addEventListener('touchend', () => {
      if (state.linkPressed) unlockTouch();
    }, true);

    sliderContainer.addEventListener('click', (e) => {
      const link = e.target.closest('a.er_new-reviews__card__content__link');
      if (!link) return;
      if (state.moved) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.stopPropagation();
    }, true);
  };

  attachDragGuard(reviewsCarousel, '.er_new-reviews__slider');

  window.addEventListener('scroll', () => {
    InitAutoplay(reviewsCarousel, 'er_new-reviews', 6000);
  });
};
